<script>
import TablePage from '@/found/components/table_page';
import FormDetail from './form_detail.vue';

export default {
  extends: TablePage,
  data() {
    return {};
  },
  components: { FormDetail },
  props: {
    dataObj: Object,
  },
  mounted() {
    this.params = {
      visitUserNames: this.dataObj.row.relUserCodeReqVos, startVisitDate: this.dataObj.row.executeBeginDate, endVisitDate: this.dataObj.row.executeEndDate, visitBigType: 'VISIT,UNFAMILIAR_VISIT',
    };
    this.getConfigList('sfaCenter_visitManage_visitDetail_list', true, false, 'CRM20201126000000098');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') return this.btnDetail(row);
    },
    btnDetail(row) {
      this.formName = 'FormDetail';
      this.formConfig.row = { ...row };
      this.modalConfig.title = '查看 详情';
      this.openFull();
    },
  },
};
</script>
